.kr{color:var(--status-error);}